module.exports = __webpack_public_path__ + "img/logoReact.c61a9852.svg";